import { FC, useMemo } from 'react';
import {
  NavigationItemKey,
  getNavigationItems,
  NavigationItem,
} from 'components/navigation/utils/libs';
import { useUser } from 'modules/user/userSelector';
import { useAccount } from 'modules/account/accountSelector';
import { useAppLayoutState } from 'components/appLayout/appLayoutState';
import RouteTabSwitcher from 'components/shared/RouteTabSwitcher';
import CalendarViewModeSwitch from 'app/modules/posts/components/postsLayout/postsLayoutContentBar/CalendarViewModeSwitch';

const VIEW_MODE_SWITCH_KEYS = [
  NavigationItemKey.PostsCalendar,
  NavigationItemKey.PostsList,
  NavigationItemKey.PostsBoard,
  NavigationItemKey.PostsGrid,
];

const PostsViewSwitcher: FC = () => {
  const user = useUser();
  const account = useAccount();
  const { showGridViewOptionInNavigation } = useAppLayoutState();

  const postsRoutes = useMemo((): NavigationItem[] => {
    const navigationItems = getNavigationItems({ account, user });

    const postsNavItem = navigationItems.find(
      (item) => item.key === NavigationItemKey.Posts,
    );

    if (!postsNavItem?.items) {
      return [];
    }

    return postsNavItem.items.filter(
      (item) =>
        !item.isDisabled &&
        (showGridViewOptionInNavigation ||
          item.key !== NavigationItemKey.PostsGrid) &&
        (!user.isClient || item.key !== NavigationItemKey.PostsList),
    );
  }, [account, user, showGridViewOptionInNavigation]);

  return (
    <RouteTabSwitcher
      routes={postsRoutes}
      renderActiveAccessory={(route) =>
        route.key && VIEW_MODE_SWITCH_KEYS.includes(route.key) ? (
          <CalendarViewModeSwitch
            key={route.key}
            showMobileView={route.key === NavigationItemKey.PostsGrid}
          />
        ) : null
      }
    />
  );
};

export default PostsViewSwitcher;
